





const Bussiness =()=>(
    <div className="flex flex-col items-center mb-10 w-full pl-4">
       <p className="sm:mb-10 mb-5 text-xs flex-wrap text-center md:p-3">PayPal Services in India are provided by PayPal Payments Private Limited (CIN U74990MH2009PTC194653). Users are advised to read the terms and conditions carefully.</p>
       <div className="flex mt-10 flex-wrap sm:flex-nowrap  justify-center sm:ml-40 lg:ml-0">
        <div className="flex flex-col w-72 mr-10 cursor-pointer ">
            <h1 className="text-blue-950 text-extrabold text-md font-medium ">Small-to-Medium Bussiness</h1>
            <hr/>
            <div className="flex justify-between mt-4 ">
                <div>
                    <p className="sm:text-sm text-xs hover:underline mb-2 text-bold font-medium">Introduction</p>
                    <p className="sm:text-sm text-xs hover:underline -bold font-medium">Getting Started</p>
                </div>
                <ul>
                    <li className="sm:text-sm text-xs hover:underline mb-2 font-medium">All Soultions</li>
                    <li className="sm:text-sm text-xs hover:underline mb-2">Accept Payment</li>
                    <li className="sm:text-sm text-xs hover:underline mb-2">Make Payment</li>
                    <li className="sm:text-sm text-xs hover:underline mb-2">Manage Risk</li>
                    <li className="sm:text-sm text-xs hover:underline mb-2">Accelerate Growth</li>
                    <li className="sm:text-sm text-xs hover:underline">Streamline Operation</li>
                </ul>
            </div>
        </div>
        <div className="flex flex-col w-72 mr-10 cursor-pointer text-blue-950">
            <h1 className="font-medium">Enterprice</h1>
            <hr/>
            <div className="flex justify-between mt-4">
                <div>
                    <p className="sm:text-sm text-xs hover:underline mb-2 font-medium">Introduction</p>
                    <p className="sm:text-sm text-xs hover:underline mb-2 font-medium">Market places & Partners</p>
                </div>
                <ul>
                    <li className="sm:text-sm text-xs hover:underline mb-2 font-medium">All Soultions</li>
                    <li className="sm:text-sm text-xs hover:underline mb-2">Accept Payment</li>
                    <li className="sm:text-sm text-xs hover:underline mb-2">Make Payment</li>
                    <li className="sm:text-sm text-xs hover:underline mb-2">Manage Risk</li>
                    <li className="sm:text-sm text-xs hover:underline mb-2">Accelerate Growth</li>
                    <li className="sm:text-sm text-xs text-grey hover:underline">Streamline Operation</li>
                </ul>
            </div>
        </div>
        <div className="lg:mr-10 cursor-pointer mr-48">
            <h1 className="font-medium text-blue-950">More</h1>
            <hr/>
            <ul className="mt-4">
                <li className="sm:text-sm text-xs hover:underline mb-2 font-medium">Nonprofits</li>
                <li className="sm:text-sm text-xs hover:underline mb-2 font-medium">Pricing</li>
                <li className="sm:text-sm text-xs hover:underline font-medium">Resourse Center</li>
            </ul>
        </div>
       </div>
    </div>
)


export default Bussiness